import { Api } from '@/api'
import router from '@/router'
import { systemFlags } from '@/utils/flags/system'

export default {
    async startup ({ commit, rootGetters }) {
        await commit('flags/SET_TRUE', systemFlags.LOADING, { root: true })
        if (rootGetters['auth/isAuth']) {
            const { ok, data } = await Api().users.me()
            if (ok && data) await commit('SET_USER', data)
            else router.push({ name: 'Signout' })
        }
        await commit('flags/REMOVE', systemFlags.LOADING, { root: true })
    },
    async cleanAll ({ commit }) {
        await commit('system/CLEAN', null, { root: true })
        await commit('auth/CLEAN', null, { root: true })
    },
}
